import React from "react";
import { Link } from "react-router-dom";
// import VerifiedBig from "../../../assests/images/OrderComp_Verified.svg";
import Auth from "../../../auth/Auth";

function FinishModal({ closeModal }) {
  return (
    <>
      <div className="modalbg">
        <div className="order_com_modal">
          <div className="order_com_modal_inner">
            <div className="heading_top">
              <h2 className="everyday_color">ThankYou!</h2>
            </div>
            <div className="img_center_verified">
              <svg width="135" height="135" viewBox="0 0 135 135">
                <defs></defs>
                <path
                  style={{ fill: "#4e74f6" }}
                  d="M133.443,63.115,121.679,49.07l1.645-18.6a6.6,6.6,0,0,0-4.87-7.056L101,19.33,91.888,3.241a6.231,6.231,0,0,0-7.97-2.7L67.536,7.857,51.154.537a6.155,6.155,0,0,0-7.906,2.7L34.076,19.264,16.682,23.353a6.51,6.51,0,0,0-4.934,6.99L13.393,49,1.565,63.115a6.832,6.832,0,0,0,0,8.7L13.393,85.864l-1.645,18.661a6.6,6.6,0,0,0,4.87,7.056l17.457,4.154,9.108,16.024a6.252,6.252,0,0,0,7.97,2.7l16.382-7.451,16.382,7.319a6.155,6.155,0,0,0,7.906-2.7l9.108-16.024,17.457-4.154a6.535,6.535,0,0,0,4.87-7.056l-1.645-18.6L133.38,71.753a6.668,6.668,0,0,0,.063-8.638Zm-77.1,23.013L42.932,72.149a6.6,6.6,0,0,1-1.367-2.133,6.833,6.833,0,0,1,0-5.032,6.6,6.6,0,0,1,1.367-2.133,6.3,6.3,0,0,1,2.046-1.425,6.069,6.069,0,0,1,4.827,0,6.3,6.3,0,0,1,2.046,1.425l8.918,9.3L83.159,48.806A6.3,6.3,0,0,1,85.2,47.381a6.069,6.069,0,0,1,4.827,0,6.3,6.3,0,0,1,2.046,1.425,6.6,6.6,0,0,1,1.367,2.133,6.833,6.833,0,0,1,0,5.032A6.6,6.6,0,0,1,92.077,58.1L65.259,86.062a6.066,6.066,0,0,1-8.918.066Z"
                />
              </svg>
            </div>
            <p className="mt-5 mb-5">Are you sure you want to share the detail of orders.</p>
            <div className="order_complete_btn">
              <Link to="user-details">
                <button className="">Yes</button>
              </Link>
              <p className="mt-4 mb-4">OR</p>
              <Link to={`/?id/${Auth.getCompanyHexaID()}`}>
                <button type="button" className="back_order">
                  Back to home
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FinishModal;
